import React from 'react';
import { Box } from 'pounceV2';
import { useTheme, SxProps, Theme } from '@mui/material';

interface BulletDividerV3Props {
  sx?: SxProps<Theme>;
}

const BulletDividerV3: React.FC<BulletDividerV3Props> = ({ sx }) => {
  const theme = useTheme();
  return (
    <Box
      as="span"
      data-testid="bullet-divider"
      width="6px"
      height="6px"
      backgroundColor={theme.palette.tokens.content.assets.neutral[3]}
      borderRadius="circle"
      mx="5px"
      sx={sx}
    />
  );
};

export default BulletDividerV3;
